/**
 * Check if two objects are shallowly equal.
 *
 * @param {Object} object1 - The first object to compare.
 * @param {Object} object2 - The second object to compare.
 * @param {boolean} [looseEquality=false] - Whether to use loose equality (==) or strict equality (===) for value comparison.
 * @returns {boolean} - True if the objects are shallowly equal, false otherwise.
 */
export default function shallowEqual(object1, object2, looseEquality = false) {
    const object1Keys = Object.keys(object1);
    const object2Keys = Object.keys(object2);

    if (object1Keys.length !== object2Keys.length) return false;

    for (var key of object1Keys) {
        const value1 = object1[key];
        const value2 = object2[key];

        if (looseEquality ? value1 != value2 : value1 !== value2) {
            return false;
        }
    }

    return true;
}
